module.exports = __webpack_public_path__ + "5ac65a8b.png";